var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1FF5B892-1340-428A-BECE-9EECB8BE5F6C@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PA/Topic-Page_L1",
    transform: "translate(-1360.000000, -166.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-68",
    transform: "translate(30.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(1330.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.837,0 32,7.163 32,16 C32,24.837 24.837,32 16,32 C7.163,32 0,24.837 0,16 C0,7.163 7.163,0 16,0 Z M23.507,10.813 C25.018,9.303 22.714,6.96 21.165,8.509 L15.989,13.684 L10.813,8.509 C9.303,6.959 6.96,9.302 8.509,10.813 L13.684,15.989 L8.509,21.165 C6.959,22.714 9.302,25.018 10.813,23.507 L15.989,18.331 L21.165,23.507 C22.714,25.018 25.018,22.714 23.507,21.165 L18.331,15.989 L23.507,10.813 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCrossIcon);
export default __webpack_public_path__ + "static/media/big-cross-icon.1824579fb8220e0be10748f8a5741e9e.svg";
export { ForwardRef as ReactComponent };